import { useAuthContext } from '@context/auth/useAuthContext';
import useUiContext from '@context/ui/useUiContext';
import { Button } from 'antd';
import React from 'react';
import { FiLogOut } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import UserDropdown from '../../UserDropdown';

const BottomAvatar: React.FC = () => {
  const { isSidebarCollapsed } = useUiContext();
  const { user } = useAuthContext();
  const { logout } = useAuthContext();
  const { t } = useTranslation();

  return (
    <div className="w-full px-4 py-2 flex items-center justify-between bg-app-gray-light hover:bg-app-gray-2 transition">
      {/* Left: Avatar + Text */}
      <div className="flex items-center gap-3 overflow-hidden">
        <UserDropdown />
        {/* Only show name/email if sidebar is not collapsed */}
        {!isSidebarCollapsed && (
          <div className="flex flex-col overflow-hidden">
            <span className="text-sm font-semibold truncate">{user.fullname}</span>
            <span className="text-xs truncate">{user.email}</span>
          </div>
        )}
      </div>

      {/* Right: Logout Icon */}
      <Button
        className="!bg-white/10 hover:!bg-white/20 !border-none group"
        onClick={() => {
          logout();
        }}
        title={t('common-sign-out')}
        icon={<FiLogOut className="!text-white/80" />}
      />
    </div>
  );
};

export default BottomAvatar;
